export const KEY_TOKEN = "token";
export const KEY_TOKEN_REMEMBER = "token-remember";
export const ONE_MONTH = 2592000;
